import { productSkuIds } from '../config';
import { useLocation } from 'react-router-dom';

const broadbandSkuByProductId: Record<string, string> = {
  lfw: productSkuIds.broadbandLightningFastWiFi.primary,
  lfwb: productSkuIds.broadbandLightningFastWiFiBoost.primary,
  wifi100: productSkuIds.broadbandWifi100.primary,
  wifi100b: productSkuIds.broadbandWifi100Boost.primary,
  starter: productSkuIds.broadbandEssnFibre.primary,
  starterb: productSkuIds.broadbandEssnFibBoost.primary,
};

const getBroadbandSkuFromProductId = (productID: string | null) => {
  if (!productID) {
    return '';
  }

  return broadbandSkuByProductId[productID] ?? '';
};

function useGetWifiGuyRecommendations() {
  const GetWifiGuyRecommendedSku = () => {
    const search = useLocation().search;
    const productId = new URLSearchParams(search).get('product');
    return getBroadbandSkuFromProductId(productId);
  };

  /* This is only for logged-in user. */
  const GetWifiGuySelectedTui = () => {
    const search = useLocation().search;
    return new URLSearchParams(search).get('tui');
  };

  /* This is for non-logged in user. */
  const GetWifiGuySelectedAddressId = () => {
    const search = useLocation().search;
    return new URLSearchParams(search).get('addressId');
  };

  const GetWifiGuySelectedSrc = () => {
    const search = useLocation().search;
    return new URLSearchParams(search).get('src');
  };

  const wifiGuyRecommendedSku = GetWifiGuyRecommendedSku();
  const wifiGuySelectedTui = GetWifiGuySelectedTui();
  const wifiGuySelectedAddressId = GetWifiGuySelectedAddressId();
  const wifiGuySelectedSrc = GetWifiGuySelectedSrc();

  return {
    wifiGuyRecommendedSku,
    wifiGuySelectedAddressId,
    wifiGuySelectedTui,
    wifiGuySelectedSrc,
  };
}

export { useGetWifiGuyRecommendations };
